module.exports = __webpack_public_path__ + "assets/3f4e47965d72226e275a9a6d4615d368.png";